// Import the `Accordion` class from the `./accordion` module
import { Accordion } from './js/accordion';

// Define an `AccordionGroup` class
export class AccordionGroup {
	// Constructor function that takes a DOM element `el` as a parameter
	constructor(el) {
		// Check if the `el` parameter is present
		if (el) {
			// Store the `el` parameter as an instance variable
			this.el = el;

			// Query all the `.em-accordion` elements within `el`
			this.accordionEls = [...this.el.querySelectorAll('.em-accordion')];

			// If any `.em-accordion` elements are found
			if (this.accordionEls.length) {
				// Create a new `Accordion` object for each `.em-accordion` element
				this.accordions = this.accordionEls.map((accordionEl) => {
					// Query the control and content elements within the `.em-accordion` element
					const control = accordionEl.querySelector('.em-accordion__control');
					const content = accordionEl.querySelector('.em-accordion__content');

					// Create a new `Accordion` object with the `control`, `content`, and `group` properties
					return new Accordion({
						control,
						content,
						group: this,
					});
				});
			}
		}
	}
}

document.addEventListener('DOMContentLoaded', () => {
	// Query all the `.em-accordions` elements on the page
	const accordions = [...document.querySelectorAll('.em-accordions')];

	// If any `.em-accordions` elements are found
	if (accordions.length) {
	// Create a new `AccordionGroup` object for each `.em-accordions` element
		embark.components.accordions = accordions.map((el) => new AccordionGroup(el));
	}
});
